import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IDirective} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {gettextCatalog} from "angular-gettext";
import {BrukerRessurs} from "felles/tjenester/ressurser/BrukerRessurs";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";


const css = require('./byttPassord.scss');

export function byttPassordForInjisering() {
    return [byttPassord];
}

export function byttPassord(): IDirective {
    return {
        restrict: "E",
        replace: true,
        template: require('./byttPassord.html'),
        scope: {
            vedLukk: "&"
        },
        controller: ByttPassordKontroller.regNavn,
        controllerAs: 'ktr',
        bindToController: true
    };
}

export class ByttPassordKontroller {
    static regNavn = "wm.bruker.direktiver.ByttPassordKontroller";

    static forInjisering() {
        return [
            BrukerRessurs.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            ByttPassordKontroller
        ]
    }

    constructor(private brukerRes: BrukerRessurs,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog) {
        this.resetPassordSpesifikasjon();
    }

    vedLukk: Function;

    spesifikasjon: l.NyttPassordModell;
    eksisterendePassordFeil = false;
    lagrer = false;

    lukk() {
        this.resetPassordSpesifikasjon();
        this.eksisterendePassordFeil = false;
        this.vedLukk();
    }

    lagreNyttPassord(skjema) {
        this.lagrer = true;
        this.brukerRes.nyttPassord(this.spesifikasjon).$promise
            .then(() => {
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Nytt passord er registrert"));
                this.lukk();
            }).catch(() => {
            this.eksisterendePassordFeil = true;
        }).finally(() => {
            this.lagrer = false;
        });
    }

    private resetPassordSpesifikasjon() {
        this.spesifikasjon = {eksisterendePassord: "", nyttPassord: ""};
    }
}
